<template>
  <div v-if="this.first_message" class="alert" :class="'alert-' + this.first_message.type">
    <a href="#" class="close" data-dismiss="alert" aria-label="close" @click="close_alert()"
      >&times;</a
    >
    <p>
      <strong>{{ this.first_message.title }}</strong>
    </p>
    <p><span v-html="this.first_message.body"></span></p>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
  computed: {
    ...mapGetters(['messages']),
    first_message() {
      return this.messages[0];
    },
  },
  methods: {
    ...mapMutations(['pop_message']),
    close_alert() {
      const index = this.messages.indexOf(this.first_message);
      if (index > -1) {
        this.messages.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped></style>
